import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getSandData } from '@/service/production/proReportAggregate';
export default function useSandData(date) {
  var sandData = ref({
    pro_num: 0,
    material_name: '',
    status: '',
    soil: {}
  });
  var sandEle = ref({
    tonEle: '',
    totalEle: ''
  });
  var sandListData = ref([]);
  // 获取制砂总汇
  var getSandDataAsyc = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getSandData(date.value);
          case 2:
            data = _context.sent;
            sandData.value = {
              material_name: data.stoneSum.material_name,
              pro_num: data.stoneSum.pro_num,
              status: data.status,
              soil: data.soil
            };
            sandListData.value = data.list;
            sandEle.value.tonEle = data.stoneSum.tonEle;
            sandEle.value.totalEle = data.stoneSum.totalEle;
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getSandDataAsyc() {
      return _ref.apply(this, arguments);
    };
  }();
  return [sandData, sandListData, sandEle, getSandDataAsyc];
}